import RoleCard from './RoleCard.vue';
export default {
  components: {
    RoleCard
  },
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    }
  },
  watch: {
    zhsRole: {
      handler(value) {
        let result = [];

        if (value == 1) {
          result = [{
            name: '管理员',
            role: 1
          }, {
            name: '教师',
            role: 2
          }, {
            name: '学生',
            role: 3
          }];
        } else if (value == 2) {
          result = [{
            name: '教师',
            role: 2
          }, {
            name: '学生',
            role: 3
          }];
        }

        this.roleList = result;
        this.currentRole = value;
      },

      immediate: true
    }
  },

  data() {
    return {
      roleList: [],
      currentRole: 0,
      // 学堂链接
      onlineLink: {
        manage: 'https://onlineweb.zhihuishu.com/onlineMuster/managerIndex',
        teacher: 'https://hike-course-homepage.zhihuishu.com/tch/EduPlatform',
        student: 'https://onlineweb.zhihuishu.com/onlinestuh5'
      },
      manageMenu: [{
        name: '教学指挥中心',
        link: 'https://hike-course-homepage.zhihuishu.com/managerCenter/home?sid=1204',
        img: require('@/assets/images/home/教学指挥中心.png')
      }, {
        name: '数据大屏',
        link: 'https://hike-large-screen-h5.zhihuishu.com/#/cdtu',
        img: require('@/assets/images/home/数据大屏.png')
      }, {
        name: '数据中心',
        link: 'https://dch5.zhihuishu.com/newDataCenter.html#/dataOverview?sid=1204',
        img: require('@/assets/images/home/数据中心.png')
      }, {
        name: '教学日报',
        link: 'https://dch5.zhihuishu.com/dailyData.html#/dailyData/4Yda9gdv',
        img: require('@/assets/images/home/教学日报.png')
      }, {
        name: '督导中心',
        link: 'https://cdtuxkdd.zhihuishu.com/xkdd/hike-boot/AuthSys/getAuthorize?redirectUri=https://cdtuxkdd.zhihuishu.com/admin/welcome&failRedirectUri=https://cdtuxkdd.zhihuishu.com/login',
        img: require('@/assets/images/home/督导中心.png')
      }, {
        name: '评估中心',
        link: 'https://cdtupgzx.zhihuishu.com/pgzx/hike-boot/AuthSys/getAuthorize?redirectUri=https://cdtupgzx.zhihuishu.com/&failRedirectUri=https://cdtupgzx.zhihuishu.com&source=undefined',
        img: require('@/assets/images/home/评估中心.png')
      }, {
        name: '评审平台',
        link: 'https://cdtupms.zhihuishu.com/review/hike-boot/AuthSys/getAuthorize?redirectUri=https://cdtupms.zhihuishu.com&failRedirectUri=https://cdtupms.zhihuishu.com/login',
        img: require('@/assets/images/home/金课评审.png')
      }, {
        name: '教研中心',
        link: '/teachCenter.html',
        img: require('@/assets/images/home/教研中心.png')
      }],
      teacherMenu: [{
        name: '课程中心',
        link: 'https://cdtupgzx.zhihuishu.com/pgzx/hike-boot/AuthSys/getAuthorize?redirectUri=https://cdtupgzx.zhihuishu.com/prdIndex&failRedirectUri=https://cdtupgzx.zhihuishu.com&source=undefined',
        img: require('@/assets/images/home/课程中心.png')
      }, {
        name: '题库',
        link: 'https://questionbankh5.zhihuishu.com/questionList/1/1?tab=1&source=1',
        img: require('@/assets/images/home/题库.png')
      }, {
        name: '资源库',
        link: 'https://hikeweb.zhihuishu.com/RSRCcenter/resourceCenter/resourceCenter/cloudLibrary',
        img: require('@/assets/images/home/资源库.png')
      }, {
        name: 'AI资源库',
        link: 'https://hikeweb.zhihuishu.com/hike-tch/resource?type=2',
        img: require('@/assets/images/home/AI资源库.png')
      }, {
        name: '课程思政',
        link: 'https://cdtuckcsz.zhihuishu.com/alzx/hike-boot/AuthSys/getAuthorize?redirectUri=https://cdtuckcsz.zhihuishu.com/index.html&failRedirectUri=https://cdtuckcsz.zhihuishu.com/login.html',
        img: require('@/assets/images/home/课程思政.png')
      }, {
        name: '群文件管理',
        link: 'https://ct.zhihuishu.com/classroomTools/gpFile/home',
        img: require('@/assets/images/home/群文件管理1.png')
      }, {
        name: '评审平台',
        link: 'https://cdtupms.zhihuishu.com/review/hike-boot/AuthSys/getAuthorize?redirectUri=https://cdtupms.zhihuishu.com&failRedirectUri=https://cdtupms.zhihuishu.com/login',
        img: require('@/assets/images/home/评审平台.png')
      }, {
        name: '督导中心',
        link: 'https://cdtuxkdd.zhihuishu.com/xkdd/hike-boot/AuthSys/getAuthorize?redirectUri=https://cdtuxkdd.zhihuishu.com/admin/welcome&failRedirectUri=https://cdtuxkdd.zhihuishu.com/login',
        img: require('@/assets/images/home/督导中心.png')
      }],
      studentMenu: [{
        name: '消息通知',
        link: 'https://onlineh5.zhihuishu.com/onlineWeb.html#/student/noticeCenter?entry=1&noticeType=0',
        img: require('@/assets/images/home/消息通知.png')
      }, {
        name: '群文件管理',
        link: 'https://ct.zhihuishu.com/classroomTools/gpFile/home',
        img: require('@/assets/images/home/群文件管理.png')
      }, {
        name: '帮助中心',
        link: 'https://hike-course-homepage.zhihuishu.com/helpCenter',
        img: require('@/assets/images/home/帮助中心.png')
      }]
    };
  },

  methods: {
    toggleZhsRole(data) {
      this.currentRole = data.role;
    },

    zhsLogin() {
      const host = window.location.protocol + '//' + window.location.host; // const loginUrl = host + '/index.html'

      const url = host + '/index.html';
      window.location.href = `${host}/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${url}&source=${this.$schoolId}`;
    }

  }
};